import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { env } from './env';

const domain = env.REACT_APP_AUTH0_DOMAIN
  ? env.REACT_APP_AUTH0_DOMAIN
  : '';
const clientId = env.REACT_APP_AUTH0_CLIENT_ID
  ? env.REACT_APP_AUTH0_CLIENT_ID
  : '';

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('w_Root')
);
